import { faCaretDown, faCaretLeft } from "@fortawesome/pro-solid-svg-icons";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import parse from "html-react-parser";
import { useState } from "react";

interface PageIntroProps {
  text: string;
  title?: string;
  titleColor?: string;
  marginClassNames?: string;
  backgroundColor?: string;
  iconColor?: string;
  textColor?: string;
  textSize?: string;
  showIcon?: boolean;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
}

const PageIntro = ({
  text,
  title,
  titleColor = "text-sky-800",
  marginClassNames = "",
  backgroundColor,
  iconColor,
  textColor,
  textSize = "text-sm",
  showIcon = true,
  collapsible = false,
  defaultCollapsed = false,
}: PageIntroProps) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(defaultCollapsed);

  // Define styling based on variant
  let bgStyle = backgroundColor || "bg-sky-50";
  let textColorStyle = textColor || "text-sky-700";
  let iconColorStyle = iconColor || "text-sky-600";

  return (
    <div
      className={cx(
        "rounded-lg",
        marginClassNames,
        bgStyle,
        isCollapsed && collapsible ? "py-2 px-5" : "p-5",
        isCollapsed && collapsible ? "transition-all duration-200" : ""
      )}
    >
      {title && (
        <div
          className={cx("flex items-center", {
            "cursor-pointer": collapsible,
            "mb-1": !isCollapsed || !collapsible,
          })}
          onClick={() => collapsible && setIsCollapsed(!isCollapsed)}
        >
          <div
            className={cx(
              "grow flex items-center",
              isCollapsed && collapsible ? "text-lg" : "text-xl",
              "font-semibold",
              titleColor
            )}
          >
            {parse(title)}
          </div>
          {collapsible && (
            <div className="ml-2 flex items-center justify-center h-7 w-7 rounded-full hover:bg-sky-100 transition-colors duration-200">
              <FontAwesomeIcon
                size="sm"
                icon={isCollapsed ? faCaretLeft : faCaretDown}
                className="text-sky-600"
              />
            </div>
          )}
        </div>
      )}

      {(!collapsible || !isCollapsed) && (
        <div className={cx("flex gap-3", { "ml-0": title })}>
          {showIcon && (
            <FontAwesomeIcon
              icon={faCircleInfo}
              className={cx("mt-0.5 flex-shrink-0", iconColorStyle)}
            />
          )}
          <div
            className={cx(
              textSize,
              textColorStyle,
              "page-intro-text leading-relaxed"
            )}
          >
            {parse(text)}
          </div>
        </div>
      )}
    </div>
  );
};

export default PageIntro;
